var scope_0 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/172995f37aac7de457623c10e87c8711.js').default;
var scope_1 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c92b30ea288b8238f7c04e65fa5a759.js').default;
var scope_2 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/222735973d7b37dbc1538ffc6f618297.js').default;
var scope_3 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48faca91ac37cd80584b84e49fbcd3a4.js').default;
var scope_4 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/644522ede77c3e63cdf7efa77c931717.js').default;
var scope_5 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/74f6edc3cadd5ed6c8a8825d33526db6.js').default;
var scope_6 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7dbd3360aaffb30e892f89f788b90a88.js').default;
var scope_7 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/828d21b25a4f7777630a5fb918005a35.js').default;
var scope_8 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8c523407e8ba16b77307fbb03cd8c8ca.js').default;
var scope_9 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/945cb937050418a825f2a013ec5df7d0.js').default;
var scope_10 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/98df562508969cd989561cac85e6eb59.js').default;
var scope_11 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/abe35767bb70d381039847154633e121.js').default;
var scope_12 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b68852e8b636831a1bd439ce2dabbe86.js').default;
var scope_13 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9b6a88f8be5f28753165b717a0307e7.js').default;
var scope_14 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd538502be293dcebbb9c7a735fc1559.js').default;
var scope_15 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_16 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f107b3c5a49282a89f90cdbde54cd38b.js').default;
var scope_17 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4cfa68a42514c8c5a388f8f5e0b5be3.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17 )
    